<dx-popup [(visible)]="visible"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          width="60%"
          height="90%"
          [fullScreen]="fullScreen"
          [showTitle]="true"
          [title]="editMode ? ('Lieferant ändern' | translate) : ('Lieferant anlegen' | translate)"
          [showCloseButton]="true">
  <dxi-popup-toolbar-item toolbar="bottom"
                          location="after"
                          widget="dxButton"
                          [options]="{ text: editMode ? ('Lieferant ändern' | translate) : ('Lieferant anlegen' | translate), onClick: save }">
  </dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item toolbar="top"
                          location="after"
                          widget="dxButton"
                          [options]="{
                            icon : fullScreen ? 'collapse' : 'fullscreen',
                            hint: fullScreen ? 'Minimize' : 'Maximize',
                            onClick: toggleFullScreen
                          }">
  </dxi-popup-toolbar-item>
  <div *dxTemplate="let data of 'content'">
    <dx-responsive-box id="editProductDataSourceBox" [cols]="[{ ratio:1 }, { ratio:1 }]"
                       [rows]="[{ ratio:1 }, { ratio:1 }, { ratio:1 }, { ratio:1 }]"
                       width="100%" height="100%">

      <dxi-item [location]="{ row:0, col:0}">
        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Unternehmensinformationen' | translate }}</div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.name" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Typ' | translate }}</div>
              <div class="dx-field-value">
                <dx-lookup
                  [items]="types"
                  [(value)]="dataSource.type"
                  valueExpr="value"
                  displayExpr="text">
                </dx-lookup>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Kreditoren-Nr.' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.kreditorNr"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Alternative Namen' | translate }}</div>
              <div class="dx-field-value">
                <dx-tag-box [(value)]="selectedAltNames"
                            [items]="altNameOptions"
                            [acceptCustomValue]="true"
                            [showSelectionControls]="true"
                            [searchEnabled]="true"
                            (onCustomItemCreating)="addAlternativeName($event)"
                            (onValueChanged)="onAltNamesChanged($event)"
                            stylingMode="outlined">
                </dx-tag-box>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">{{ 'Straße' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.addressObj.street" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'PLZ' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.addressObj.zip" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Stadt' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.addressObj.city" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Country Code' | translate }}</div>
              <div class="dx-field-value">
                <dx-select-box [dataSource]="countryCodes"
                               valueExpr="code"
                               displayExpr="label"
                               [searchEnabled]="true"
                               [searchExpr]="['name','code']"
                               searchMode="contains"
                               [minSearchLength]="0"
                               [maxItemCount]="countryCodes?.length"
                               [dropDownOptions]="{ maxHeight: 300 }"
                               [(value)]="dataSource.countryCode"
                               (valueChange)="onCountryChanged($event)">
                </dx-select-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Website' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.website" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
          </div>
        </div>
      </dxi-item>

      <dxi-item [location]="{ row:0, col:1}">
        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <span *ngIf="!dataSource.logoFile"
                  class="glyphicon glyphicon-picture"></span>
            <img *ngIf="dataSource.logoFile"
                 [src]="dataSource.logoFile"
                 alt="Logo Preview"
                 class="logo-preview" />
            <dx-file-uploader uploadUrl="api/DataSources/UploadLogo"
                              [allowedFileExtensions]="['.jpg', '.jpeg', '.png', '.gif']"
                              [uploadHeaders]="uploadHeaders"
                              [uploadCustomData]="{
                              dataSourceId: dataSource.id,
                              customerId: loginService.currentUser.customerId
                            }"
                              [multiple]="false"
                              accept="*"
                              (onUploaded)="onUploaded($event)"
                              (onBeforeSend)="onBeforeSendUpload($event)"
                              [(value)]="value"
                              uploadMode="instantly">
            </dx-file-uploader>
          </div>
        </div>

        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'zugehörige Marken' | translate }}</div>
            <div>
              <dx-list class="brand-list" [items]="relatedBrands">
                <ng-template dxTemplate="item" let-text>
                  {{ text }}
                </ng-template>
              </dx-list>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item [location]="{ row:1, col:0, colspan:2}">
        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Beschreibung' | translate }}</div>
            <dx-html-editor class="scroll-editor" [(value)]="dataSource.description" height="100%" width="100%">
              <dxo-toolbar>
                <dxi-item name="undo"></dxi-item>
                <dxi-item name="redo"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="bold"></dxi-item>
                <dxi-item name="italic"></dxi-item>
                <dxi-item name="underline"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="alignLeft"></dxi-item>
                <dxi-item name="alignCenter"></dxi-item>
                <dxi-item name="alignRight"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="header" [acceptedValues]="[1, 2, 3, 4, 5, false]"></dxi-item>
                <dxi-item name="separator"></dxi-item>
                <dxi-item name="orderedList"></dxi-item>
                <dxi-item name="bulletList"></dxi-item>
              </dxo-toolbar>
            </dx-html-editor>
          </div>
        </div>
      </dxi-item>
      <dxi-item [location]="{ row:2, col:0}">
        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Informationen für das Produktsicherheitsgesetz' | translate }}</div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name des Ansprechpartners' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.contactPerson" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Support Tel.Nr' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.supportTel" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Support-E-Mail' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.supportMail" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div id="garanty-label" class="dx-field-label">{{ 'Link zu Garantie / Produktsicherheitsseite' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.warrantyPages" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Support Website' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.supportWebsite" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item [location]="{ row:2, col:1}">
        <div *ngIf="!this.isEuCountry" class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Informationen zum Importeur' | translate }}</div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Name des Importeurs' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.importerName" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Straße' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.importerAddress.street" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'PLZ' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.importerAddress.zip" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Stadt' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.importerAddress.city" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Land' | translate }}</div>
              <div class="dx-field-value">

                <dx-select-box [dataSource]="countryCodes"
                               valueExpr="code"
                               displayExpr="label"
                               [searchEnabled]="true"
                               [searchExpr]="['name','code']"
                               searchMode="contains"
                               [minSearchLength]="0"
                               [maxItemCount]="countryCodes?.length"
                               [dropDownOptions]="{ maxHeight: 300 }"
                               [(value)]="dataSource.importerCountryCode">
                </dx-select-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Website' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.importerWebsite" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item [location]="{ row:3, col:0}">
        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Zusatzinformationen' | translate }}</div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Ansprechpartner' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.salesContact" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Vertriebswebsite' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.salesSupportWebsite" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'E-Mail des Unternehmens' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.salesMail" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Telefonnummer' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.salesTel" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
          </div>
        </div>
      </dxi-item>
      <dxi-item *ngIf="this.loginService.hasAddonElectronicSales" [location]="{ row:3, col:1}">
        <div class="dx-card card-compact">
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{ 'Seo' | translate }}</div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Meta-Title' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.seoMetaTitle" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Meta-Description' | translate }}</div>
              <div class="dx-field-value">
                <dx-text-box [(value)]="dataSource.seoMetaDescription" [showClearButton]="true"></dx-text-box>
              </div>
            </div>
          </div>
        </div>
      </dxi-item>
    </dx-responsive-box>
  </div>
</dx-popup>
